module.exports = __webpack_public_path__ + "static/media/ezond.32f07dc1.png";